<template>
  <div class="container">
    <div class="wrapper">
      <Title :data="video" />
      <div class="message">
        <Date :data="video" />
        <p :style="{ fontSize: fontSize.p + 'em' }" class="source">
          資料來源:{{ video.source }}
        </p>
      </div>
      <!-- <ShareBtns /> -->
      <div class="video_content">
        <div class="video_wrap">
          <div class="video">
            <div v-html="video.originalFilePath" class="content_words"></div>
          </div>
        </div>

        <div class="txt">
          <p
            :style="{ fontSize: fontSize.p + 'em' }"
            v-html="video.abstract"
          ></p>
        </div>
      </div>
      <FurtherReading
        v-if="relatedData.items.length"
        :keywords="relatedData.keywords"
        :items="relatedData.items"
      />
    </div>
  </div>
</template>

<script setup>
import { inject, watch } from "vue";
import Title from "../components/Title.vue";
import Date from "../components/Date.vue";
import ShareBtns from "@/components/ShareBtns.vue";
import FurtherReading from "@/components/FurtherReading.vue";
import { useRoute } from "vue-router";
import { apiVideo } from "@/api/api.js";
import { reactive } from "@vue/reactivity";

let fontSize = inject("fontSize");
const route = useRoute();
const vid = route.params.id;

apiVideo(vid)
  .then((res) => {
    console.log(res.data);
    setData(res.data);
  })
  .catch((res) => {
    console.log("Failed", res);
  });

const setData = (data) => {
  setVideoData(data);
  setFurtherReadingData(data);
};

const video = reactive({
  vid: "",
  nodeName: "",
  pageTitle: "",
  abstract: "",
  originalFilePath: "",
  pagePublishUp: "",
  source: "",
});

const setVideoData = ({
  vid,
  nodeName,
  title,
  abstract,
  originalFilePath,
  uploadDate,
  source,
}) => {
  video.vid = vid;
  video.nodeName = nodeName;
  video.pageTitle = title;
  video.abstract = abstract;
  video.originalFilePath = originalFilePath ? originalFilePath : "";
  video.pagePublishUp = uploadDate;
  video.source = source;
};

const relatedData = reactive({
  keywords: [],
  items: [],
});

const setFurtherReadingData = (data) => {
  relatedData.keywords = data.keywords ? data.keywords : [];
  relatedData.items = data.furtherReads ? data.furtherReads : [];
};

watch(
  () => route.params.id,
  (currentId) => {
    apiVideo(currentId).then((res) => {
      setData(res.data);
    });
  }
);
</script>

<style scoped lang="scss">
.video_content {
  @include CulFlex_center;
  margin: 0px 60px 80px;
  @include lg {
    margin: 0px 20px 80px;
  }
  .video_wrap {
    width: 50%;
    margin: 0 auto;
    padding: 40px 0 30px;
    @include xl {
      width: 70%;
    }
    @include lg {
      width: 100%;
      padding: 25px 0 15px;
    }
  }
  .video {
    position: relative;
    width: 100%;
    height: 0;
    margin: 0 auto;
    padding-bottom: 56.25%;
    :deep iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .txt {
    width: 70%;
    text-align: left;
    font-size: $h5;
  }
}

.message {
  @include flex();
  .source {
    margin-left: 20px;
  }
}

.content_words {
  width: 70%;
  text-align: initial;
  font-size: $h5;
}
</style>
